module.exports = __webpack_public_path__ + "static/media/instagram.476d4c87.svg";